
import { FaChartSimple, FaFileLines, FaTowerBroadcast, FaUsers, FaUserTie, FaBriefcase, FaRobot, FaAddressBook , FaUser, FaNewspaper  } from "react-icons/fa6";

import * as routes from './routes';
import { ROLES } from "./roleConstants";

export const SIDE_BAR_MENUS = [
    {
        title: "My Dashboard",
        icon: <FaChartSimple />,
        link: routes.BASE_PATH_PREFIX,
        roles: [ROLES.ADMIN, ROLES.INVESTOR, ROLES.SUPER_ADMIN]
    },
    
    { title: "My Holdings", icon: <FaBriefcase />, link: routes.MY_HOLDINGS, roles: [ROLES.INVESTOR] },
    
    { title: "My Profile", icon: <FaUser />, link: routes.MY_PROFILE, roles: [ROLES.INVESTOR] },

    { title: "My Documents", icon: <FaFileLines />, link: routes.MY_DOCUMENTS, roles: [ROLES.INVESTOR] },

    
    {
        title: "Communication",
        icon: <FaTowerBroadcast />,
        link: routes.COMMUNICATION,
        roles: [ROLES.ADMIN, ROLES.INVESTOR, ROLES.SUPER_ADMIN]
    },
    {
        title: "Contact Us",
        icon: <FaAddressBook />,
        link: routes.CONTACTUS,
        roles: [ROLES.INVESTOR]
    },
    { title: "User Management", icon: <FaUsers />, link: routes.USERS, roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] },
    { title: "Content Management", icon: <FaNewspaper />, link: routes.CONTENT_MANAGEMENT, roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] },
    { title: "Data Center Automation", icon: <FaRobot />, link: routes.DATA_CENTER_AUTOMATION, roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] },
    //{ title: "Investor Management", icon: <FaUserTie />, link: routes.INVESTORS_MANAGEMENT, roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] },
    { title: "HoldCo Management", icon: <FaBriefcase />, link: routes.HOLDCO_MANAGEMENT, roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] },
    //{ title: "Document Master", icon: <FaFileLines />, link: routes.DOCUMENT_MASTER, roles: [ROLES.ADMIN, ROLES.SUPER_ADMIN] },

];

// export const SIDE_BAR_MENUS = [
//     {
//         title: "My Dashboard",
//         icon: <FaChartSimple />,
//         link: routes.BASE_PATH_PREFIX
//     },
//     {
//         title: "Communication",
//         icon: <FaTowerBroadcast />,
//         link: routes.COMMUNICATION_PATH
//     },
//     {
//         title: "Investment",
//         icon: <FaSackDollar />,
//         subMenus: [
//             { title: "Transaction", icon: <FaBriefcase />, link: routes.MY_INVESTMENT_PATH },
//             { title: "Documents", icon: <FaFileLines />, link: routes.DOCUMENTS_PATH },
//             // { title: "Portfolio", icon: <FaChartPie />, link: routes.PORTFOLIO_PATH },
//             // { title: "Vesting", icon: <FaDna />, link: routes.VESTING_PATH },
//         ],
//     },
//     // {
//     //     title: "Transactions",
//     //     icon: <FaMoneyCheckDollar />,
//     //     link: routes.TRANSACTIONS_PATH
//     // },
//     {
//         title: "Admin",
//         icon: <FaUser />,
//         subMenus: [
//             // { title: "Admin Configuration", icon: <FaGear />, link: routes.CONFIGURATION },
//             { title: "Users", icon: <FaUsers />, link: routes.USERS },
//             // { title: "Notification and Communication", icon: <FaBell />, link: routes.NOTIFICATIONS },
//             { title: "Data Upload Centers", icon: <FaCloudArrowUp />, link: routes.DATA_UPLOAD_CENTERS },
//             { title: "Data Center Automation", icon: <FaRobot />, link: routes.DATA_CENTER_AUTOMATION },
//             { title: "Investors", icon: <FaUserTie />, link: routes.INVESTORS_PATH },
//             // { title: "Bulk Update Demo", icon: <FaFileImport />, link: routes.INVESTOR_BULK_UPDATE_DEMO },
//             { title: "Investment Bulk Update", icon: <FaFileImport />, link: routes.INVESTOR_BULK_UPDATE },
//         ]
//     }
// ];
